const eventKeyRegExp = window.location.href.match(/\/watch\/(.*?)\//);
export const eventKey = eventKeyRegExp && eventKeyRegExp[1].replace('/', '');